<template src="./index.html"></template>
<script>
import common from './index';
export default {
    mixins: [common],
    data: function() {
        return {
            mapTheme: 'layout1'
        };
    }
};
</script>
<style lang="scss">
@import '../map/css/layout1/index.scss';
</style>
